<template>
  <el-dialog
    ref="dialog"
    class="com_dialog confirm_dialog"
    :title="dialogTitle"
    :append-to-body="true"
    :visible.sync="visibleDialog"
    :close-on-press-escape="closeOnPressEscape"
    :close-on-click-modal="closeOnClickModal"
    :before-close="handleClose"
    :custom-class="customClass"
    width="460px"
  >
    <div class="dialog-body">
      <div class="left">
        <img :src="src" alt="">
      </div>
      <div class="right">
        <div class="title">{{title}}</div>
        <div class="msg">{{ message }}</div>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
        <el-button size="mini" type="secondary" @click="handleClose">{{cancelButtonText}}</el-button>
        <el-button size="mini" :type="['lock','delete'].includes(type)? 'warning':'primary'" @click="handleSure">{{confirmButtonText}}</el-button>
      </span>
  </el-dialog>
</template>

<script>

export default {
  name: 'ConfirmDialog',
  inheritAttrs: false,
  computed: {
    src() {
      if (this.type === 'info') {
        return require('@/assets/confirmDialog/icon-laba.png')
      }
      if (this.type === 'delete') {
        return require('@/assets/confirmDialog/icon-delete.png')
      }
      if (this.type === 'warning') {
        return require('@/assets/confirmDialog/icon-delete.png')
      }
      if (this.type === 'lock') {
        return require('@/assets/confirmDialog/lock@2x.png')
      }
      if (this.type === 'lingdang') {
        return require('@/assets/confirmDialog/lingdang@2x.png')
      }
      return require('@/assets/confirmDialog/icon-laba.png')
    }
  },
  watch: {
    attrs(val) {
      // console.log(val.secTitle)
    },
    visibleDialog(val){
      const dom = $('.icon-drag-dual');
      if(dom.length > 0){
        if(val){
          dom.addClass('icon-drag-dual-hidden');
        }
        else{
          dom.removeClass('icon-drag-dual-hidden');
        }
      }
    }
  },
  data() {
    return {
      visibleDialog: true,
      dialogTitle: '', // 弹窗标题
      title: '提示', // 外界传值过来，展示
      message: '', // 内容
      type: 'info', // 弹窗类型 info,error,delete,warning,lock,lingdang
      cancelButtonText: '取消',
      confirmButtonText: '确定',
      isCancelBtn: true, // 是否展示取消按钮
      isSureBtn: true, // 是否展示确认按钮
      isTitleText: true, // 是否展示title
      closeOnClickModal: false,
      closeOnPressEscape: false,
      customClass: 'customConfirmDialogClass222'
    }
  },
  mounted() {
    // console.log(this.$attrs)

  },
  methods: {

    show(cb) {
      this.visibleDialog = true
      typeof cb === 'function' && cb.call(this, this)
      return new Promise((resolve, reject) => {
        this.reject = reject
        this.resolve = resolve
      })
    },
    handleClose() {
      this.reject('cancel')
      this.visibleDialog = false
      this.$emit('close')
    },
    handleSure() {
      this.resolve('confirm')
      this.visibleDialog = false
      this.$emit('sure')
    },
    destroyDialog() {
      this.visibleDialog = false
      document.body.removeChild(this.$el)
      this.$destroy()
    }
  }
}
</script>

<style lang="scss" scoped>
.com_dialog.confirm_dialog {
  ::v-deep .el-dialog {
    overflow: hidden;
    .el-dialog__header {
      background: #FAFAFC;
      //padding: var(--paddings);
      padding: 4px 24px;
      .original-title {
        width: calc(100% - 30px);
        h3 {
          margin: 0;
          line-height: 26px;
          font-weight: 500;
          color: #1D2129;
          font-size: 18px;
          white-space: nowrap;
          width: 100%;
          text-overflow: ellipsis;
          overflow: hidden;
        }
        p {
          font-size: 12px;
          font-weight: 400;
          color: #86909C;
          line-height: 20px;
          white-space: nowrap;
          width: 100%;
          text-overflow: ellipsis;
          overflow: hidden;
        }
      }

    }
    .el-dialog__footer {
      border-top: 0 !important;
      .el-button{
        width: 68px;
        height: 28px;
        border-radius: 4px;
      }
    }
  }
  .dialog-body{
    display: flex;
    align-items: center;
    .left{
      img{
        width: 64px;
        height: 64px;
      }
    }
    .right{
      margin-left: 16px;
      .title {
        margin: 7px 0 8px;
        font-weight: 500;
        font-size: 16px;
        color: #1D2129;
        line-height: 22px;
        text-align: left;
        font-style: normal;
        text-transform: none;
      }
      .msg{
        font-weight: 400;
        font-size: 14px;
        color: #4E5969;
        line-height: 20px;
        text-align: left;
        font-style: normal;
        text-transform: none;
      }
    }
  }
}

</style>
<style lang="scss">
.el-tooltip__popper-content {
  p {
    word-break: break-all;
  }
}
</style>
